import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, Output, EventEmitter, ViewChild } from '@angular/core';
import { ResourceRequestModalComponent } from './resource-request-modal/resource-request-modal.component';

@Component({
  standalone: false,
  selector: 'dsp-resource-center',
  templateUrl: './resource-center.component.html',
  styleUrls: ['./resource-center.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResourceCenterComponent implements OnInit {

  @ViewChild(ResourceRequestModalComponent)
  public modal: ResourceRequestModalComponent;

  @Output()
  public showHelpBoxEvent: EventEmitter<any> = new EventEmitter<any>();

  public showGuideList = false;

  constructor() { }

  ngOnInit() {
    //empty
  }

  public showGuideListOptions(): void {
    this.showGuideList = true;
  }

  public hideGuideListOptions(): void {
    this.showGuideList = false;
  }

  public closeHelp(): void {
    this.showGuideList = false;
    this.showHelpBoxEvent.emit(false);
  }


  public openRequestModal() {
    this.modal.open();
  }
}
